module.exports = __webpack_public_path__ + "static/media/success_icon.ab0fef9f.png";